import measures from 'globals/measures'
import styled from 'styled-components'

export const AuthTemplateWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const Header = styled.div`
  width: 100%;
  padding: 37px 55px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media(max-width: 700px) {
    position: relative;
  }

  @media(max-width: ${measures.mobileThreshold}px) {
    padding: 30px 34px;
  }
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  flex: 1;

  @media(max-width: 700px) {
    justify-content: center;
    align-items: flex-start;
  }
`

export const LeftPart = styled.div`
  width: 434px;
  min-width: 434px;
  margin: 0 55px;

  @media(max-width: ${measures.mobileThreshold}px) {
    width: 100%;
    min-width: 0;
    margin: 0 34px;
  }
`

interface RightPartProps {
  maxWidth: number
}

export const RightPart = styled.div<RightPartProps>`
  max-width: ${(props) => props.maxWidth}px;
  display: flex;
  justify-content: center;
  align-items: flex-start;

  @media(max-width: 700px) {
    display: none;
  }
`

export const RightPartImg = styled.img`
  width: 100%;
  margin: 20px 55px 20px 0;
`
